// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2cXBQ","actions":"GroupTable_actions__1zp1h","deleteModalFooter":"GroupTable_deleteModalFooter__1wNCE"};